import * as React from "react";
const SvgCaretRight = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M4.37385 13.1342C4.6801 13.4404 5.17385 13.4404 5.4801 13.1342L10.6738 7.94043C10.9176 7.69668 10.9176 7.30293 10.6738 7.05918L5.4801 1.86543C5.17385 1.55918 4.6801 1.55918 4.37385 1.86543C4.0676 2.17168 4.0676 2.66543 4.37385 2.97168L8.89885 7.50293L4.3676 12.0342C4.0676 12.3342 4.0676 12.8342 4.37385 13.1342Z",
	fill: "currentColor"
}));
export default SvgCaretRight;
